export default "__VITE_ASSET__f5de9ab7__"